import styled, { css } from 'styled-components';
export var Wrapper = styled.div.withConfig({
  componentId: "rjjmid-0"
})(["width:100%;position:relative;margin:0 auto;opacity:", ";", ";"], function (_ref) {
  var width = _ref.width,
      height = _ref.height,
      playerInited = _ref.playerInited;
  return width || height || playerInited ? 1 : 0;
}, function (_ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      resized = _ref2.resized;
  return width && height && css(["max-width:", "px;min-height:", ";"], width, resized ? 'auto' : "".concat(height, "px"));
});
export var Preview = styled.div.withConfig({
  componentId: "rjjmid-1"
})(["position:absolute;top:0;left:0;right:0;bottom:0;z-index:5;img{width:100%;object-fit:cover;}"]);
export var ContainerWrapper = styled.div.withConfig({
  componentId: "rjjmid-2"
})(["opacity:", ";"], function (_ref3) {
  var isInited = _ref3.isInited;
  return isInited ? 1 : 0;
});